import { combineReducers } from 'redux';
import api from './api/reducer';
import auth from './auth/reducer';
import ui from './ui/reducer';

export default combineReducers({ api, auth, ui });
